export default __webpack_public_path__ + "static/media/react.c2861c4d.png";